import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { MatFormFieldControl, MatRadioChange } from '@angular/material';
import { AbstractMatFormFieldControl } from '@mctic/ng-core';
import { TipoOrigemEnum } from '../../enum/tipo-origem.enum';
import { Option } from '../../model';

@Component({
  selector: 'app-radio-origem-tecnologia',
  providers: [{provide: MatFormFieldControl, useExisting: OrigemTecnologiaRadioComponent}],
  template: `
    <mctic-radio-button
      [controlName]="controlName"
      [options]="opcoes"
      optionLabel="label"
      optionValue="value"
      flexDirection="row"
      (selectionChange)="selectionChange.emit($event)"
    >
    </mctic-radio-button>
  `
})
export class OrigemTecnologiaRadioComponent extends AbstractMatFormFieldControl<boolean> {

  @Output()
  selectionChange: EventEmitter<MatRadioChange> = new EventEmitter<MatRadioChange>();

  protected opcoes: Option<TipoOrigemEnum>[] = [
    {label: 'Nacional', value: TipoOrigemEnum.Nacional},
    {label: 'Estrangeira', value: TipoOrigemEnum.Estrangeira}
  ];

  constructor(injector: Injector) {
    super(injector);
  }

}
